import {SET_DATE, SET_FULLTEXT, SET_HDBL, SET_ONLINE, SET_OFFLINE} from '../types/filters'

function shouldChangeStateForFulltext(phrase) {
    return phrase.length >= 3;

}

export function setFulltextSearch(phrase) {
    if (shouldChangeStateForFulltext(phrase)) {
        return {
            type: SET_FULLTEXT,
            data: phrase
        }
    }
    return {
        type: SET_FULLTEXT,
        data: null
    }
}

export function changeHdblState(state) {
    return {
        type: SET_HDBL,
        data: state
    }
}


export function changeOnlineState(state) {
    return {
        type: SET_ONLINE,
        data: state
    }
}

export function changeOfflineState(state) {
    return {
        type: SET_OFFLINE,
        data: state
    }
}

export function changeDate(state) {
    return {
        type: SET_DATE,
        data: state
    }
}


// WEBPACK FOOTER //
// ./src/actions/filters.js